<!-- オブジェクト選択リスト -->
<template>
  <v-card>
    <v-card-title class="d-flex align-center justify-space-between">
      {{ $t("SELECT_OBJECT") }}
      <v-btn icon variant="flat" @click="close()">
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="object-select-scroll-area">
      <!-- 仮設道路追加 -->
      <v-container class="ma-4">
        <v-row>
          <v-col>
            <v-card class="object-select-btn card-btn">
              <v-row>
                <v-col cols="2" class="icon">
                  <img class="mr-1" :src="TemporaryRoadIcon" alt="Temporary Road Icon">
                </v-col>
                <v-col cols="10" @click="clickOnDialog('road')">
                  <v-card-title class="card-btn-title"> {{ $t("Addtemporaryroad") }} </v-card-title>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- 平場追加 -->
      <v-container class="object-select-btn ma-4">
        <v-row>
          <v-col>
            <v-card class="card-btn">
              <v-row>
                <v-col cols="2" class="icon">
                  <img class="mr-1" :src="FlatFieldIcon" alt="Temporary Road Icon">
                </v-col>
                <v-col cols="10" @click="clickOnDialog('ground')">
                  <v-card-title class="card-btn-title"> {{ $t("Addflatground") }} </v-card-title>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- 床掘 -->
      <v-container class="object-select-btn ma-4">
        <v-row>
          <v-col>
            <v-card class="card-btn">
              <v-row>
                <v-col cols="2" class="icon">
                  <img class="mr-1" :src="DiggingIcon" alt="Temporary Road Icon">
                </v-col>
                <v-col cols="10" @click="clickOnDialog('trench')">
                  <v-card-title class="card-btn-title"> {{ $t("Addtemporarytrench") }} </v-card-title>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- 簡易構造物追加 -->
      <v-container class="object-select-btn ma-4">
        <v-row>
          <v-col>
            <v-card class="card-btn">
              <v-row>
                <v-col cols="2" class="d-flex align-center justify-center">
                  <v-icon size="large"> mdi-drawing </v-icon>
                </v-col>
                <v-col cols="10" @click="clickOnDialog('simpleStructure')">
                  <v-card-title class="card-btn-title"> {{ $t("SIMPLE_STRUCTURE") }} </v-card-title>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- 根伐り -->
      <v-container class="object-select-btn ma-4" v-if="isFoundationExcavationEnabled">
        <v-row>
          <v-col>
            <v-card class="card-btn">
              <v-row>
                <v-col cols="2" class="d-flex align-center justify-center">
                  <v-icon size="large"> mdi-excavator </v-icon>
                </v-col>
                <v-col cols="10" @click="clickOnDialog('foundation_excavation')">
                  <v-card-title class="card-btn-title"> {{ $t("Addfoundationexcavation") }} </v-card-title>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- AIによる道路追加 -->
      <v-container v-if="isRoadAiVisible" class="object-select-btn ma-4">
        <v-row>
          <v-col>
            <v-card class="card-btn" :disabled="isRoadAiDisabled">
              <v-row>
                <v-col cols="2" class="d-flex align-center justify-center">
                  <v-icon size="large"> mdi-robot </v-icon>
                </v-col>
                <v-col cols="10" @click="clickOnDialog('roadAI')">
                  <v-card-title class="card-btn-title"> {{ $t("RoadadditionbyAI") }} </v-card-title>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import DiggingIcon from "@/assets/icons/customIcons/digging-icon.svg";
import FlatFieldIcon from "@/assets/icons/customIcons/flat-field-icon.svg";
import TemporaryRoadIcon from "@/assets/icons/customIcons/temporary-road-icon.svg";
import {
	GoogleAnalyticsClickTypes,
	addClickTypeLog,
} from "../../utils/googleAnalytics.js";

export default {
	components: {},
	name: "SelectObject",
	props: {
		isRoadAiVisible: {
			type: Boolean,
			default: false,
		},
		isRoadAiDisabled: {
			type: Boolean,
			default: true,
		},
	},
	mounted: () => {},
	data: () => ({
		TemporaryRoadIcon,
		FlatFieldIcon,
		DiggingIcon,
		enableAIRoadCreation: false, // selectObjectからのAI道路追加のシーケンスを蓋閉じ
		isFoundationExcavationEnabled:
			window.featureFlag?.foundationExcavation ?? false,
	}),
	methods: {
		close() {
			this.$emit("close");
		},
		clickOnDialog(type) {
			if (type === "roadAI" && this.isRoadAiDisabled) {
				return;
			}

			// Google Analyticsに連携
			const target = {
				road: GoogleAnalyticsClickTypes.P_CLICK_ADD_ROAD,
				ground: GoogleAnalyticsClickTypes.P_CLICK_ADD_PLANE,
				trench: GoogleAnalyticsClickTypes.P_CLICK_ADD_TRENCH,
			};
			addClickTypeLog(target[type]);

			// 仮設道路追加
			if (type === "road") this.$emit("data-to-parent", "road");
			// 平場追加
			else if (type === "ground") this.$emit("data-to-parent", "ground");
			// 床掘追加
			else if (type === "trench") this.$emit("data-to-parent", "trench");
			// 根伐り
			else if (type === "foundation_excavation")
				this.$emit("data-to-parent", "foundation_excavation");
			// AIによる道路追加
			else if (type === "roadAI") this.$emit("data-to-parent", "roadAI");
			// 簡易構造物追加
			else if (type === "simpleStructure")
				this.$emit("data-to-parent", "simple_structure");
			// ダイアログ選択画面閉じる
			this.close();
		},
	},
};
</script>

<style scoped>
.card-btn {
  display: flex;
  align-items: center;
  height: 90px;
}

.card-btn:hover {
  background-color: #2e2e2e;
}

.card-btn-title {
  white-space: normal
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.object-select-btn {
  width: 90%;
}

.object-select-scroll-area {
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.white-icon {
  filter: brightness(0) invert(1);
  width: 25px;
}
</style>
